import axios from "axios";

//const baseURL = 'https://bdgwhapi.azurewebsites.net/api'
const baseURL = "https://apiv2.codikash.com/api";

const connection = axios.create({
  baseURL: baseURL,
});

connection.interceptors.request.use((config) => {
  config.headers = {
    "Access-Control-Allow-Origin": "*",
  };
  return config;
});

export default connection;
